import { useEffect, useMemo } from 'react';
import classNames from 'classnames';

import { useMainMachine } from '../../../utils/useMainMachine';
import { Select } from '../basic-ui/Select';
import { ACTIONS } from '../../../state';
import { LUCKY } from '../../constants';

export function VoiceSelector({ wrapperClassName, selectProps = {} }) {
  const { useSelector, machine } = useMainMachine();
  const voice = useSelector(({ context }) => context.voice);
  const voices = useSelector(({ context }) => context.brandGuidelines?.voices.filter((v) => v.enabled === true) ?? []);

  const VOICE_OPTIONS = useMemo(
    () => [
      {
        value: LUCKY,
        label: <span className="text-white">I&apos;m feeling lucky!</span>,
      },
      ...voices.map((v) => ({
        value: v.name,
        label: (
          <span style={{ '--selectedvoice': v.color }} className="text-selectedvoice">
            {v.name}
          </span>
        ),
      })),
    ],
    [voices],
  );

  useEffect(() => {
    // in case selected voice has been deleted, fall back to the default lucky
    if (!VOICE_OPTIONS.find((v) => v.value === voice)) {
      machine.send({ type: ACTIONS.CHANGE_VOICE, voice: LUCKY });
    }
  }, [voice, VOICE_OPTIONS, machine]);

  return (
    <div className={classNames('w-[160px]', wrapperClassName)}>
      <Select
        aria-label="voice selector"
        options={VOICE_OPTIONS}
        value={voice}
        onChange={(v) => machine.send({ type: ACTIONS.CHANGE_VOICE, voice: v })}
        renderInPortal={true}
        popperClassName="!z-[100000]"
        {...selectProps}
      />
    </div>
  );
}
